import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltKeySetupService {

  constructor(private http: HttpClient) { }

  /**
   * Get SLT Key Setup data from the API
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param taxYear Tax year from rowData
   * @param mefGroupKey MEF Group Key from rowData
   * @returns Observable with key setup data
   */
  getKeySetupData(
    baseUrl: string,
    taxYear: any,
    mefGroupKey: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32711&tax_year=${taxYear}&mef_group_key=${mefGroupKey}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Re-sync group data
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param taxYear Tax year from rowData
   * @param groupKey Group Key from rowData
   * @returns Observable with re-sync response
   */
  reSyncGroup(
    baseUrl: string,
    taxYear: any,
    groupKey: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32737&tax_year=${taxYear}&group_key=${groupKey}`;
    
    return this.http.post<any>(url, null, { withCredentials: true });
  }
}
